import { render, staticRenderFns } from "./CreateInvoiceTab.vue?vue&type=template&id=6d8b2a1a&scoped=true&"
import script from "./CreateInvoiceTab.vue?vue&type=script&lang=js&"
export * from "./CreateInvoiceTab.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoiceTab.vue?vue&type=style&index=0&id=6d8b2a1a&scoped=true&lang=css&"
import style1 from "./CreateInvoiceTab.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b2a1a",
  null
  
)

export default component.exports